import i18n from '@/i18n/index'

const orderManager = [
  {
    path: '/ordersManager',
    component: () => import('@/views/ordersManager/index.vue'),
    meta: { name: i18n.t('menu.orderManagement'), allowBreadcrumbRedirect: false },
    children: [
      {
        // 售后订单
        path: '/ordersManager/afterSalesOrders',
        component: () => import('@/views/ordersManager/afterSalesOrders/index.vue'),
        meta: { name: i18n.t('menu.afterSaleOrder'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'ordersManagerAfterSalesOrdersList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'ordersManagerAfterSalesOrdersList',
            component: () => import('@/views/ordersManager/afterSalesOrders/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'ordersManagerAfterSalesOrdersDetail',
            component: () => import('@/views/ordersManager/afterSalesOrders/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          },
          {
            path: 'downloadCenter',
            name: 'afterSalesOrdersDownloadCenter',
            component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
            meta: { name: i18n.t('menu.downloadCenter'), keepAlive: false }
          }
        ]
      },
      {
        // 拆分订单
        path: '/ordersManager/breakDownOrders',
        component: () => import('@/views/ordersManager/breakDownOrders/index.vue'),
        meta: { name: i18n.t('menu.breakDownOrders'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'ordersManagerBreakDownOrdersList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'ordersManagerBreakDownOrdersList',
            component: () => import('@/views/ordersManager/breakDownOrders/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'ordersManagerBreakDownOrdersDetail',
            component: () => import('@/views/ordersManager/breakDownOrders/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          },
          {
            path: 'downloadCenter',
            name: 'breakDownDownloadCenter',
            component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
            meta: { name: i18n.t('menu.downloadCenter'), keepAlive: false }
          }
        ]
      },
      {
        // 配送订单
        path: '/ordersManager/deliveryOrders',
        component: () => import('@/views/ordersManager/deliveryOrders/index.vue'),
        meta: { name: i18n.t('menu.orderDeliver'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'ordersManagerDeliveryOrdersList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'ordersManagerDeliveryOrdersList',
            component: () => import('@/views/ordersManager/deliveryOrders/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'ordersManagerDeliveryOrdersDetail',
            component: () => import('@/views/ordersManager/deliveryOrders/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          },
          {
            path: 'downloadCenter',
            name: 'deliveryOrdersDownloadCenter',
            component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
            meta: { name: i18n.t('menu.downloadCenter'), keepAlive: false }
          }
        ]
      },
      {
        // 用户订单
        path: '/ordersManager/userOrders',
        component: () => import('@/views/ordersManager/userOrders/index.vue'),
        meta: { name: i18n.t('menu.userOrder'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'ordersManagerUserOrdersList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'ordersManagerUserOrdersList',
            component: () => import('@/views/ordersManager/userOrders/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'ordersManagerUserOrdersDetail',
            component: () => import('@/views/ordersManager/userOrders/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          },
          {
            path: 'downloadCenter',
            name: 'userOrdersDownloadCenter',
            component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
            meta: { name: i18n.t('menu.downloadCenter'), keepAlive: false }
          }
        ]
      },
      {
        // 门票订单
        path: '/ordersManager/ticketOrders',
        component: () => import('@/views/ordersManager/ticketOrders/index.vue'),
        meta: { name: i18n.t('menu.ticketOrder'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'ordersManagerticketOrdersList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'ordersManagerticketOrdersList',
            component: () => import('@/views/ordersManager/ticketOrders/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'ordersManagerTicketOrdersDetail',
            component: () => import('@/views/ordersManager/ticketOrders/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          }
          // {
          //   path: 'downloadCenter',
          //   name: 'userOrdersDownloadCenter',
          //   component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
          //   meta: { name: i18n.t('menu.downloadCenter'), keepAlive: false }
          // }
        ]
      },
      {
        // 门票订单
        path: '/ordersManager/hotelOrders',
        component: () => import('@/views/ordersManager/hotelOrders/index.vue'),
        meta: { name: i18n.t('menu.hotelOrder'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'ordersManagerhotelOrdersList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'ordersManagerhotelOrdersList',
            component: () => import('@/views/ordersManager/hotelOrders/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'ordersManagerHotelOrdersDetail',
            component: () => import('@/views/ordersManager/hotelOrders/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          }
        ]
      },
      {
        // 堂食订单
        path: '/ordersManager/dineinOrders',
        component: () => import('@/views/ordersManager/dineinOrders/index.vue'),
        meta: { name: i18n.t('menu.dineinOrders'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'ordersManagerDineinOrdersList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'ordersManagerDineinOrdersList',
            component: () => import('@/views/ordersManager/dineinOrders/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'ordersManagerDineinOrdersDetail',
            component: () => import('@/views/ordersManager/dineinOrders/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          }
        ]
      }
    ]
  }
]

// const orderManager = [
//   {
//     path: '/ordersManager/managerDeliveryOrders',
//     name: 'managerDeliveryOrders',
//     component: () => import(/* webpackChunkName: 'addressTypes' */ '@/views/ordersManager/managerDeliveryOrders/managerDeliveryOrders.vue'),
//     meta: { name: i18n.t('menu.orderDeliver'), show: true, index: 14, menu: true },
//     children: [
//       {
//         path: '/ordersManager/managerDeliveryOrders/managerDeliveryOrdersView',
//         name: 'managerDeliveryOrdersView',
//         component: () => import(/* webpackChunkName: 'addressTypes' */ '@/views/ordersManager/managerDeliveryOrders/managerDeliveryOrdersView.vue'),
//         meta: { name: i18n.t('menu.orderDetail', { name: i18n.t('menu.orderDeliver') }), show: false },
//         beforeEnter: (to, from, next) => {
//           if (from.name === 'managerDeliveryOrders' || from.name === 'managerUserOrderView') {
//             next()
//           } else {
//             next({
//               name: 'managerDeliveryOrders'
//             })
//           }
//         }
//       },
//       {
//         path: '/ordersManager/managerDeliveryOrders/downloadCenter',
//         name: 'deliveryOrdersDownloadCenter',
//         component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
//         meta: { name: i18n.t('menu.downloadCenter'), show: false, children: true },
//         beforeEnter: (to, from, next) => {
//           if (from.name === 'managerDeliveryOrders') {
//             next()
//           } else {
//             next({
//               name: 'managerDeliveryOrders'
//             })
//           }
//         }
//       }
//     ]
//   },
//   {
//     path: '/ordersManager/managerUserOrders',
//     name: 'managerUserOrder',
//     component: () => import(/* webpackChunkName: 'addressTypes' */ '@/views/ordersManager/managerUserOrders/managerUserOrders.vue'),
//     meta: { name: i18n.t('menu.userOrder'), show: true, index: 14, menu: true },
//     children: [
//       {
//         path: '/ordersManager/managerUserOrders/downloadCenter',
//         name: 'userOrdersDownloadCenter',
//         component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
//         meta: { name: i18n.t('menu.downloadCenter'), show: false, children: true },
//         beforeEnter: (to, from, next) => {
//           if (from.name === 'managerUserOrder') {
//             next()
//           } else {
//             next({
//               name: 'managerUserOrder'
//             })
//           }
//         }
//       },
//       {
//         path: '/ordersManager/managerUserOrders/managerUserOrderView',
//         name: 'managerUserOrderView',
//         component: () => import(/* webpackChunkName: 'addressTypes' */ '@/views/ordersManager/managerUserOrders/managerUserOrderView.vue'),
//         meta: { name: i18n.t('menu.orderDetail', { name: i18n.t('menu.userOrder') }), show: false },
//         beforeEnter: (to, from, next) => {
//           if (from.name === 'managerUserOrder' || from.name === 'managerDeliveryOrdersView' || from.name === 'managerDeliveryOrders' || from.name === 'managerAfterSalesOrders' || from.name === 'managerBreakDownOrders' || from.name === 'managerAfterSalesOrdersView' || from.name === 'managerAfterSalesOrdersView') {
//             next()
//           } else {
//             next({
//               name: 'managerUserOrder'
//             })
//           }
//         }
//       }
//     ]
//   },
//   {
//     path: '/ordersManager/managerAfterSalesOrders',
//     name: 'managerAfterSalesOrders',
//     component: () => import(/* webpackChunkName: 'addressTypes' */ '@/views/ordersManager/managerAfterSalesOrders/managerAfterSalesOrders.vue'),
//     meta: { name: i18n.t('menu.afterSaleOrder'), show: true, index: 14, menu: true },
//     children: [
//       {
//         path: '/ordersManager/managerAfterSalesOrders/managerAfterSalesOrdersView',
//         name: 'managerAfterSalesOrdersView',
//         component: () => import(/* webpackChunkName: 'addressTypes' */ '@/views/ordersManager/managerAfterSalesOrders/managerAfterSalesOrdersView.vue'),
//         meta: { name: i18n.t('menu.orderDetail', { name: i18n.t('menu.afterSaleOrder') }), show: false },
//         beforeEnter: (to, from, next) => {
//           if (from.name === 'managerAfterSalesOrders' || from.name === 'managerUserOrderView') {
//             next()
//           } else {
//             next({
//               name: 'managerAfterSalesOrders'
//             })
//           }
//         }
//       }
//     ]
//   },
//   {
//     path: '/ordersManager/managerBreakDownOrders',
//     name: 'managerBreakDownOrders',
//     component: () => import(/* webpackChunkName: 'addressTypes' */ '@/views/ordersManager/managerBreakDownOrders/managerBreakDownOrders.vue'),
//     meta: { name: i18n.t('menu.breakDownOrders'), show: true, index: 14, menu: true },
//     children: [
//       {
//         path: '/ordersManager/managerBreakDownOrders/downloadCenter',
//         name: 'breakDownOrdersDownloadCenter',
//         component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
//         meta: { name: i18n.t('menu.downloadCenter'), show: false, children: true },
//         beforeEnter: (to, from, next) => {
//           if (from.name === 'managerBreakDownOrders') {
//             next()
//           } else {
//             next({
//               name: 'managerBreakDownOrders'
//             })
//           }
//         }
//       }
//     ]
//   }
// ]

export default orderManager
